import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button, Card, CardBody, CardHeader, Table } from 'reactstrap';
import { axios } from '../../services/axios';
import CreateMenuTypeModal from './CreateMenuTypeModal';
import EditMenuTypeModal from './EditMenuTypeModal';
import ShowMenuTypeModal from './ShowMenuTypeModal';

const MenuTypes = () => {
  const [menuTypes, setMenuTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [createModal, setCreateModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedMenuType, setSelectedMenuType] = useState(null);

  useEffect(() => {
    fetchMenuTypes();
  }, []);

  const fetchMenuTypes = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/menu-types');
      setMenuTypes(response.data);
    } catch (error) {
      console.error('Error fetching menu types:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = () => {
    setCreateModal(true);
  };

  const handleEdit = (menuType) => {
    setSelectedMenuType(menuType);
    setEditModal(true);
  };

  const handleShow = (menuType) => {
    setSelectedMenuType(menuType);
    setShowModal(true);
  };

  const handleCreateSuccess = () => {
    setCreateModal(false);
    fetchMenuTypes();
  };

  const handleEditSuccess = () => {
    setEditModal(false);
    setSelectedMenuType(null);
    fetchMenuTypes();
  };

  if (loading) {
    return <div className="loader" />;
  }

  return (
    <div className="row">
      <div className="col-md-12">
        <Card>
          <CardHeader>
            <div className="d-flex justify-content-between align-items-center">
              <h3 className="m-portlet__head-text">Menu Types</h3>
              <Button color="primary" onClick={handleCreate}>
                Create Menu Type
              </Button>
            </div>
          </CardHeader>
          <CardBody>
            <Table responsive>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name (EN)</th>
                  <th>Name (AR)</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {menuTypes.map((menuType) => (
                  <tr key={menuType.id}>
                    <td>{menuType.id}</td>
                    <td>{menuType.translations.find(t => t.locale === 'en')?.name || '-'}</td>
                    <td>{menuType.translations.find(t => t.locale === 'ar')?.name || '-'}</td>
                    <td>
                      <Button
                        color="info"
                        size="sm"
                        className="mr-2"
                        onClick={() => handleShow(menuType)}
                      >
                        Show
                      </Button>
                      <Button
                        color="primary"
                        size="sm"
                        onClick={() => handleEdit(menuType)}
                      >
                        Edit
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </div>

      <CreateMenuTypeModal
        isOpen={createModal}
        toggle={() => setCreateModal(false)}
        onSuccess={handleCreateSuccess}
      />

      {selectedMenuType && (
        <>
          <EditMenuTypeModal
            isOpen={editModal}
            toggle={() => {
              setEditModal(false);
              setSelectedMenuType(null);
            }}
            menuType={selectedMenuType}
            onSuccess={handleEditSuccess}
          />

          <ShowMenuTypeModal
            isOpen={showModal}
            toggle={() => {
              setShowModal(false);
              setSelectedMenuType(null);
            }}
            menuType={selectedMenuType}
          />
        </>
      )}
    </div>
  );
};

export default connect()(MenuTypes);
